(function () {
    'use strict';
    angular
        .module('table')
        .service('tableConfigService', tableConfigService);

        function tableConfigService() {
            return {
                showActions: true,
                normalRow: ['DISP', 'DATM'],
                lakd: 'LAKD'
            }
        }
})();
